<template>
    <article
        id="policy-details-insured-item"
        data-test-policy-insured-item
    >
        <h2>{{ value.LabelInsuredItemHeadline }}</h2>

        <field
            v-model="value.PropertyAddress"
            name="propertyAddress-string"
        />

        <field
            v-model="value.PropertyType"
            name="propertyType-string"
        />

        <field
            v-model="value.RoofingMaterial"
            name="roofingMaterial-string"
        />

        <field
            v-if="value.displayOuterWalls"
            v-model="value.OuterWalls"
            name="outerWalls-string"
        />
        <field
            v-model="value.HouseType"
            name="houseType-string"
        />

        <field
            v-if="value.displayHeatingSource"
            v-model="value.HeatingSource"
            name="heatingSource-string"
        />
        <field
            v-if="value.displayNoOfToilets"
            v-model="value.NoOfToilets"
            name="noOfToilets-number"
        />
        <field
            v-model="value.LivingArea"
            name="livingArea-number"
        />

        <field
            v-model="value.ActualLivingArea"
            name="actualLivingArea-number"
        />

        <field
            v-model="value.CommercialArea"
            name="commercial-number"
        />

        <field
            v-model="value.TotalAreaForSecondary"
            name="totalAreaForSecondary-number"
        />

        <field
            v-model="value.BasementArea"
            name="basementArea-number"
        />

        <field
            v-model="value.YearOfConstruction"
            name="yearOfConstruction-number"
        />

        <field
            v-model="value.ApprovedWaterAlarm"
            name="approvedWaterAlarm-string"
        />

        <field
            v-model="value.ApprovedFireRetardant"
            name="approvedFireRetardant-string"
        />

        <field
            v-model="value.ApprovedFloodProofingOrPumpWell"
            name="approvedFloodProofingOrPumpWell-string"
        />

        <field
            v-model="value.Swimmingpool"
            name="swimmingpool-string"
        />
        <field
            v-if="value.displaySolarPanels"
            v-model="value.SolarPanels"
            name="solarPanels-string"
        />
    </article>
</template>

<script>
import Field from '../Field.vue';

export default {
    name: 'House',
    components: {
        Field
    },
    props: {
        value: {
            type: Object,
            default() {
                return null;
            }
        }
    }
};
</script>
